import { useState, useEffect } from 'react';
import SlidePanel from './SlidePanel';
import { getTeamRoles } from '../../utils/api';

export default function TeamPanel({ open, onClose, team, onViewAsTeamLead, onEdit, setCurrentView, showToast }) {
  const [rolesData, setRolesData] = useState({ enabled: false, roles: [] });

  useEffect(() => {
    if (!open || !team?.id) return;
    getTeamRoles(team.id)
      .then(d => setRolesData(d || { enabled: false, roles: [] }))
      .catch(console.error);
  }, [open, team?.id]);

  if (!team) return null;

  return (
    <SlidePanel
      open={open}
      onClose={onClose}
      title={team.name}
      subtitle={`Lead: ${team.leadEmail || 'Unassigned'}`}
    >
      <div className="slide-section-title">Team Info</div>
      <div className="detail-row">
        <span className="detail-label">Team Lead</span>
        <span className="detail-val">{team.leadEmail || '—'}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Status</span>
        <span className="detail-val">
          <span className={`status-dot ${team.statusDot || 'dot-green'}`} />
          {team.status || 'Active'}
        </span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Default Pass Level</span>
        <span className="detail-val">{team.passLevel || 'SL'}</span>
      </div>

      {rolesData.enabled && rolesData.roles.length > 0 && (
        <>
          <div className="slide-section-title" style={{ marginTop: 16 }}>Sub-Roles</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {rolesData.roles.map(role => (
              <span
                key={role}
                style={{ fontFamily: 'var(--font-h)', fontSize: 12, fontWeight: 700, padding: '4px 10px', borderRadius: 20, background: 'var(--off)', border: '1px solid var(--border)', color: 'var(--black)' }}
              >
                {role}
              </span>
            ))}
          </div>
        </>
      )}

      <div className="slide-section-title" style={{ marginTop: 16 }}>Actions</div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        {onEdit && (
          <button className="btn btn-sm" onClick={() => { onClose(); onEdit(team); }}>
            Edit Team
          </button>
        )}
        <button
          className="btn btn-sm btn-dark"
          onClick={() => { onClose(); onViewAsTeamLead && onViewAsTeamLead(team); }}
        >
          View as Team Lead
        </button>
      </div>
    </SlidePanel>
  );
}
